import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';

export interface MealSummaryReportRequest {
  fromDate: string;
  toDate: string;
  center?: string | null;
  programId?: number;
}

export interface MealSummaryReportRow {
  userName: string;
  meal: string;
  type: string;
  drink: string;
  providedBy?: string;
  center: string;
  mealDate?: string;
}

export interface MealSummaryReportResponse {
  statusCode: number;
  message: string;
  fromDate: string;
  toDate: string;
  rows: MealSummaryReportRow[];
}

@Injectable({
  providedIn: 'root',
})
export class MealSummaryReportService {
  private readonly apiService = inject(ApiService);

  getReport(request: MealSummaryReportRequest): Observable<MealSummaryReportResponse> {
    return this.apiService.post<MealSummaryReportResponse>(
      API_ENDPOINTS.REPORTS.MEAL_SUMMARY,
      request,
    );
  }
}
